export const OWNER_STATEMENT_COLUMN_ID = 'reservation_id';
export const OWNER_STATEMENT_COLUMN_RESERVATION_TYPE = 'reservation_type';
export const OWNER_STATEMENT_COLUMN_FROM_DATE = 'from_date';
export const OWNER_STATEMENT_COLUMN_NIGHTS = 'nights';
export const OWNER_STATEMENT_COLUMN_GROSS_REVENUE = 'gross_revenue';
export const OWNER_STATEMENT_COLUMN_INV_TOTAL = 'inv_total';
export const OWNER_STATEMENT_COLUMN_RENTAL_FEE = 'rental_fee';
export const OWNER_STATEMENT_COLUMN_CLEANING_FEE = 'cleaning_fee';
export const OWNER_STATEMENT_COLUMN_OTHER_FEE = 'other_fee';
export const OWNER_STATEMENT_COLUMN_TOTAL_FEE = 'total_fee';
export const OWNER_STATEMENT_COLUMN_NET_REVENUE = 'net_revenue';
export const OWNER_STATEMENT_COLUMN_COMM_PERCENT = 'comm_percent';
export const OWNER_STATEMENT_COLUMN_COMMISSION= 'commission';
export const OWNER_STATEMENT_COLUMN_CHANNEL_COMMISSION = 'channel_commission';
export const OWNER_STATEMENT_COLUMN_NET_OWNER = 'net_owner';
export const OWNER_STATEMENT_COLUMN_MAPPING = {
    [OWNER_STATEMENT_COLUMN_ID]: 'ID',
    [OWNER_STATEMENT_COLUMN_RESERVATION_TYPE]: 'Type',
    [OWNER_STATEMENT_COLUMN_FROM_DATE]: 'Arrival',
    [OWNER_STATEMENT_COLUMN_NIGHTS]: 'Nts',
    [OWNER_STATEMENT_COLUMN_GROSS_REVENUE]: 'Gross Rev',
    [OWNER_STATEMENT_COLUMN_INV_TOTAL]: 'Inv Total',
    [OWNER_STATEMENT_COLUMN_RENTAL_FEE]: 'Rental',
    [OWNER_STATEMENT_COLUMN_CLEANING_FEE]: 'Cleaning',
    [OWNER_STATEMENT_COLUMN_OTHER_FEE]: 'Other',
    [OWNER_STATEMENT_COLUMN_TOTAL_FEE]: 'Total',
    [OWNER_STATEMENT_COLUMN_NET_REVENUE]: 'Net Revenue',
    [OWNER_STATEMENT_COLUMN_COMMISSION]: 'Amount',
    [OWNER_STATEMENT_COLUMN_COMM_PERCENT]: 'Percent',
    [OWNER_STATEMENT_COLUMN_CHANNEL_COMMISSION]: 'Channel Comm',
    [OWNER_STATEMENT_COLUMN_NET_OWNER]: 'Net To Owner',
};
